import { Button as DesignSystemButton } from '@noorden-insurtech/alba-design-system';
import type { ComponentProps } from 'react';

export type ButtonProps = ComponentProps<typeof DesignSystemButton>;

/**
 * Botão padrão do Portal.
 *
 * Ponto único de acesso ao botão do design system, que está saindo: quando ele
 * sair, só este arquivo muda. Features importam daqui, nunca do pacote.
 */
export function Button(props: ButtonProps) {
  return <DesignSystemButton {...props} />;
}
